import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import BCC from './assets/BCC.jpg'
import Flow from './assets/flowchart.jpg'
import FlowQ from './assets/flowQ.png'
import Bascis from './assets/Basics.png'
import temp from './assets/template.png'
import Io from './assets/io.gif'
import vck from './assets/vck.png'
import strRev from './assets/strRev.jpg'
import Dat from './assets/Data.png'
import loop from './assets/loop.jpeg'
import loopQ from './assets/loopQ.jpg'
import ap from './assets/ap.png'
import primec from './assets/primec++.jpg'
import Db from './assets/DB.png'
import ncr from './assets/ncr.jfif'
import pattern from './assets/pattern.png'
import Arr from './assets/Array.png'
import RevArr from './assets/RevArr.gif'
import ls from './assets/ls.jpg'
import Rtt from './assets/Rtt.png'
import bble from './assets/bble.png'
import ss from './assets/ss.png'
import str from './assets/str.jfif'
import strMax from './assets/strMax.png'
import strDup from './assets/strDup.png'
import tog from './assets/tog.png'
import rec from './assets/rec.jpeg'
import Plndrm from './assets/plndrm.png'
import perm from './assets/perm.png'
import rmz from './assets/rmz.jfif'
import Nque from './assets/nque.png'
import Oop from './assets/oop.jpeg'
import DMA from './assets/DMA.png'
import com from './assets/com.jpg'
import UserExcept from './assets/userExcept.png'
import delw from './assets/delw.png'
import ll from './assets/ll.jfif'
import del from './assets/del.webp'
import inter from './assets/inter.jpg'
import merge from './assets/merge.png'
import stkRev from './assets/stkRev.png'
import stk from './assets/stk.png'
import inPo from './assets/InPo.png'
import stkspan from './assets/stkspan.png'
import tcp from './assets/tcp.jpg'
import toh from './assets/toh.png'
import stksrt from './assets/stksrt.png'
import q from './assets/q.jfif'
import sets from './assets/Sets.jpg'
import vec from './assets/vec.jpg'
import map from './assets/map.png'
import jva from './assets/jva.jpg'
import qm from './assets/qm.jpg'
import cs from './assets/cs.png'
import Reference from './assets/Reference.png'
import sbb from './assets/sbb.png'
import oo from './assets/oo.gif'
import abst from './assets/abst.png'
import al from './assets/al.png'
import merege from './assets/merege.png'
const Java1 = () => {
    return (
        <div>

               <h1 style={{textAlign:'center'}}>Topics to be Covered</h1>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={jva}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Java Language Introduction</p>
      <NavLink to='/category/java/Introduction'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={BCC} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Basics computer Operation</p>
      <NavLink to='/category/java/Basics of Computer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Flow} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Flowchart and Pseudocodes</p>
        <NavLink to='/category/java/Flow-Chart and Pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={FlowQ} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Print Hello world 10 Times by flowchart and Pseudocode </p>
      <NavLink to='/category/java/Java - Print hello world 10 time by flow chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={FlowQ}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a pseudocode and flowchart to check give number is prime or not?</p>
      <NavLink to='/category/java/java - Check Prime or not by flow  chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={FlowQ} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a pseudocode and flowchart to find the sum of n number</p>
      <NavLink to='/category/java/Java - Sum of N natural numbers by flow chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Bascis} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Basics of Coding</p>
        <NavLink to='/category/java/Java - Basic of coding'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={temp} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Basic and Template - Printing NooB</p>
      <NavLink to='/category/java/Java - Basic and Template of Java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Io}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Input and Output</p>
      <NavLink to='/category/java/Java - Input and Output'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={vck} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Variables and Keywords</p>
      <NavLink to='/category/java/Java - Variable Constant and Keywordsl'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={qm} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Is main method is Compulsory in java?</p>
        <NavLink to='/category/java/category/java/Is main method compulsory in Java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Dat} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Data Types</p>
      <NavLink to='/category/java/Data type'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={loop}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Loop</p>
      <NavLink to='/category/java/Loops in Java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={loopQ} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}> Java Program to Print Natural Numbers from 1 to N</p>
      <NavLink to='/category/java/Java Program to Print Natural Numbers from 1 to N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ap} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Print A.P. till N</p>
        <NavLink to='/category/java/Java Program to Print AP till N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={cs} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Conditional Statement</p>
      <NavLink to='/category/java/Java Conditional statement'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={primec}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a program to check whether a number is prime or not?</p>
      <NavLink to='/category/java/Java-Check Prime or not'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Db} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a program to convert a number from Decimal to Binary</p>
      <NavLink to='/category/java/Java Convert Decimal to Binary'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ncr} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Write nCr formulae program?</p>
        <NavLink to='/category/java/Java program to find the value'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={pattern} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Pattern</p>
      <NavLink to='/category/java/Program to print the pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Arr}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Arrays</p>
      <NavLink to='/category/java/Java Arrays'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={RevArr} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Print n numbers of array in reverse order.</p>
      <NavLink to='/category/java/Java Arrays Reverse'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ls} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Write a program to do linear search.</p>
        <NavLink to='/category/java/Java Linear search'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Rtt} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Rotate a matrix by 90 clockwise .</p>
      <NavLink to='/category/java/Java matrix clockwise'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={bble}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a program to do bubble sort.</p>
      <NavLink to='/category/java/Java-Bubble sorting'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={ss} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Write a program to Selection sort.</p>
      <NavLink to='/category/java/Java-Selction sorting'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Reference} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Java Refrences</p>
        <NavLink to='/category/java/Java-Java Refrence'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={str} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>String</p>
      <NavLink to='/category/java/Java-String'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={sbb} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>String vs String Builder vs String Buffer</p>
      <NavLink to='/category/java/String vs StringBuilder vs StringBuffer in Java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    
    

  
  <div class="card 1">
    <div class="card_image"> <img src={strRev}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Reverse a string</p>
      <NavLink to='/category/java/String Reverse in Java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

  <div class="card 1">
    <div class="card_image"> <img src={strMax}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}> find the maximum occurring character in a given String</p>
      <NavLink to='/category/java/category/java/Java Program To Find Maximum And Minimum Occurring Character'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>

  
    <div class="card 2">
    <div class="card_image">
      
      <img src={strDup} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>remove all duplicates from a given string?</p>
      <NavLink to='/category/java/Remove duplicates from a given string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={tog} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Toggle the given string</p>
        <NavLink to='/category/java/Toggle the given string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={rec} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Recurssion</p>
      <NavLink to='/category/java/Recurssion in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
   
  <div class="card 1">
    <div class="card_image"> <img src={Plndrm}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Check if a number is Palindrome by recurssion</p>
      <NavLink to='/category/java/Check given number is palindrome or not'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={perm} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>print all permutation of a String?</p>
      <NavLink to='/category/java/Find the permutation of string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>

  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={rmz} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Rat in a Maze</p>
        <NavLink to='/category/java/Rat in maze'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Nque} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>N- queen Problem</p>
      <NavLink to='/category/java/N-queen problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
  
          
            <div class="card 2">
    <div class="card_image">
      
      <img src={Oop} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Oops</p>
      <NavLink to='/category/java/OOPS in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>

  <div class="card 1">
    <div class="card_image"> <img src={DMA}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>DMA- Dynamic Memory Allocation</p>
      <NavLink to='/category/java/DMA- dynamic memory allocation in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
 </div>
 </div>

 <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 2">
    <div class="card_image">
      
      <img src={com} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Class and its member</p>
      <NavLink to='/category/java/Class and its members'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
 
  
    <div class="card 2">
    <div class="card_image"> 
      <img src={oo} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Method Overloading and OverRiding</p>
      <NavLink to='/category/java/Difference between method overloading and method overriding in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
 
  
  <div class="card 1">
    <div class="card_image">
      <img src={UserExcept} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Exceptional Handling</p>
        <NavLink to='/category/java/Exceptional handling'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={abst} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Abstract list</p>
      <NavLink to='/category/java/Abstract list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
  </div>
 <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={al}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Array List</p>
      <NavLink to='/category/java/Arraylist'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>

  <div class="card 1">
    <div class="card_image"> <img src={delw}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Delete Whole Linked list</p>
      <NavLink to='/category/java/delete whole linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>

    <div class="card 2">
    <div class="card_image">
      
      <img src={ll} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Linked list</p>
      <NavLink to='/category/java/Linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={del} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Delete Values at given position</p>
        <NavLink to='/category/java/delete an element from an array from a specified location'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={inter} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Find the intersection of two linked list</p>
      <NavLink to='/category/java/intersection of two linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    
  <div class="card 1">
    <div class="card_image"> <img src={merge}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Merge sort two linked list</p>
      <NavLink to='/category/java/merge two linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={stk} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Stack</p>
      <NavLink to='/category/java/stack in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={stkRev} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Reverse the stack</p>
        <NavLink to='/category/java/Reverse the stack in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={inPo} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Infix to Postfix Conversion using Stack</p>
      <NavLink to='/category/java/Infix to Postfix'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
 
          
  <div class="card 1">
    <div class="card_image"> <img src={stkspan}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>The Stock Span Problem</p>
      <NavLink to='/category/java/The stock problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={tcp} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>The Celebrity Problem</p>
      <NavLink to='/category/java/The Celebrity problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={toh} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Iterative Tower of Hano</p>
        <NavLink to='/category/java/Tower of hanoi'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={stksrt} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Sort the stack</p>
      <NavLink to='/category/java/sort the stack'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   

  <div class="card 1">
    <div class="card_image"> <img src={q}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Queue</p>
      <NavLink to='/category/java/queue in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={sets} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Set</p>
      <NavLink to='/category/java/Set in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={merege} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Merge two set</p>
        <NavLink to='/category/java/merge set in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={vec} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Vector</p>
      <NavLink to='/category/java/Vector in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
   
           
  
  <div class="card 1">
    <div class="card_image"> <img src={map}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Map</p>
      <NavLink to='/category/java/Map in java'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    </div>
    
        </div>
    )
}

export default Java1
